import type { Currency } from '@weft/types';
import { PRICING_MODELS, type Pricing } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import { formatNumber } from '@weft/utils';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import cn from 'classnames';
import React from 'react';

type LightInvoiceProductSectionProps = React.PropsWithChildren<{
  pricing?: Pricing,
  currency?: Currency,
  name: string;
  price: string;
  type?: string;
  description?: string;
  isPdf?: boolean;
}>;

export const LightInvoiceProductSection: React.FC<LightInvoiceProductSectionProps> = ({ children, pricing, currency, name, price, type, description, isPdf = true }) => {
  const currencySymbol = getCurrencySymbol(currency);

  return (
    <div
      className={cn('border-b-line flex flex-wrap justify-between border-b px-6 tracking-wide',
        isPdf ? 'gap-1' : 'gap-3 pt-3')}
    >
      <div className='flex w-full flex-wrap justify-between'>
        <div className='flex w-full flex-wrap justify-between'>
          <div className={cn('font-medium text-black', isPdf ? 'text-lg' : 'text-xl')}>{name}</div>
          {isNotNullOrUndefined(type) && <div className={cn('font-medium', isPdf ? 'text-lg' : 'text-xl')}>{type}</div>}
          <div className={cn('font-medium text-black', isPdf ? 'text-lg' : 'text-2xl')}>
            {price}
          </div>
        </div>
        <div className='flex w-full justify-between'>
          {description && (
            <div className="text-placeholder w-full text-base font-normal">
              {description}
            </div>
          )}
          {isNotNullOrUndefined(pricing) && pricing.pricingModel === PRICING_MODELS.FixedPerUnit && (
            <div
              className="text-placeholder flex w-full flex-wrap justify-end text-base font-normal"
            >
              <div>{`${formatNumber(pricing.priceConfiguration.units)} X ${currencySymbol}${formatNumber(pricing.priceConfiguration.price)}`}</div>
            </div>
          )}
        </div>
      </div>
      <div className={cn('w-full', isPdf ? 'pb-2' : 'pb-3')}>
        {children}
      </div>
    </div>
  );
};